import { formatToRub } from 'utils';
import { CABINET_LANDING_NAME } from '../../cabinet-constants';
import { ALL_IMAGE_LIST_PRESET, CABINET_BIG_IMAGE_TRANSFORMATIONS, CABINET_IMAGE_TRANSFORMATIONS } from './cabinet-gallery-constants';
import { CabinetImageStructure, ImagePreset } from './cabinet-gallery-types';

const prepareImageList = (imagePresetList: ImagePreset[], style: string): CabinetImageStructure[] => (
  imagePresetList.map((preset, index: number) => {
    const subPath = index === 0 ? `large-card/${preset.style}` : preset.style;
    const name = style === 'all' ? preset.displayedName : '';

    return {
      alt: name,
      name,
      addText: `от ${formatToRub(preset.price)} ₽`,
      price: preset.price,
      src: `${CABINET_LANDING_NAME}/gallery/${preset.style}/${preset.mediaMainPhoto}`,
      srcSmall: index === 0 ? `${CABINET_LANDING_NAME}/gallery/${subPath}/${preset.mediaMainPhoto}` : '',
      transformations: index === 0 ? CABINET_BIG_IMAGE_TRANSFORMATIONS : CABINET_IMAGE_TRANSFORMATIONS,
    }
  })
);

export const getImageList = (style: string) => {
  if (style === 'all') {
    return prepareImageList([...ALL_IMAGE_LIST_PRESET].sort((a, b) => {
      if (a.rating === undefined && b.rating === undefined) return 0;
      else if (a.rating === undefined) return 1;
      else if (b.rating === undefined) return -1;
      else return a.rating - b.rating;
    }), style)
  }

  return prepareImageList(ALL_IMAGE_LIST_PRESET.filter(preset => preset.style === style), style);
}